export default {
  name: 'product',
  title: 'Product',
  type: 'document',
  fields: [
    {
      name: 'name',
      title: 'Name',
      type: 'string',
      validation: Rule => Rule.required(),
    },
    {
      name: 'slug',
      title: 'Slug',
      type: 'string',
      validation: Rule => Rule.required(),
    },
    {
      name: 'price',
      title: 'Price',
      type: 'number',
      validation: Rule => Rule.required().positive(),
    },
    {
      name: 'originalPrice',
      title: 'Original Price (for sales)',
      type: 'number',
    },
    {
      name: 'category',
      title: 'Category',
      type: 'string',
      options: {
        list: [
          { title: 'Accessories', value: 'accessories' },
          { title: 'Mutes', value: 'mutes' },
          { title: 'Sheet Music', value: 'sheet-music' },
          { title: 'Instruments', value: 'instruments' },
          { title: 'Digital', value: 'digital' },
          { title: 'Cases', value: 'cases' },
        ],
      },
    },
    {
      name: 'image',
      title: 'Main Image URL',
      type: 'url',
      description: 'Main image URL from Wix CDN',
    },
    {
      name: 'images',
      title: 'Additional Images',
      type: 'array',
      of: [{ type: 'url' }],
      description: 'Additional product images from Wix CDN',
    },
    {
      name: 'youtubeUrl',
      title: 'YouTube video URL',
      type: 'url',
      description: 'Single YouTube URL to show as the product video (e.g. https://youtube.com/shorts/xxxx or https://youtu.be/xxxx). Used as a fallback when "Videos by Language" is empty.',
    },
    {
      name: 'videos',
      title: 'Product Videos',
      type: 'array',
      of: [{ type: 'url' }],
      description: 'Product videos (MP4 URLs)',
    },
    {
      name: 'videosByLanguage',
      title: 'Videos by Language',
      type: 'object',
      description: 'Language-specific product videos (YouTube URLs). Leave blank to use the single "YouTube video URL" above for all languages.',
      fields: [
        { name: 'en', title: 'English', type: 'url' },
        { name: 'es', title: 'Spanish', type: 'url' },
        { name: 'de', title: 'German', type: 'url' },
        { name: 'fr', title: 'French', type: 'url' },
        { name: 'it', title: 'Italian', type: 'url' },
        { name: 'ja', title: 'Japanese', type: 'url' },
        { name: 'uk', title: 'Ukrainian', type: 'url' },
      ],
    },
    {
      name: 'badge',
      title: 'Badge',
      type: 'string',
      options: {
        list: [
          { title: 'Bestseller', value: 'BESTSELLER' },
          { title: 'Popular', value: 'POPULAR' },
          { title: 'Sale', value: 'SALE' },
          { title: 'New', value: 'NEW' },
          { title: 'Premium', value: 'PREMIUM' },
          { title: 'Out of Stock', value: 'OUT OF STOCK' },
        ],
      },
    },
    {
      name: 'featured',
      title: 'Featured',
      type: 'boolean',
      initialValue: false,
    },
    {
      name: 'outOfStock',
      title: 'Out of Stock',
      type: 'boolean',
      initialValue: false,
    },
    {
      name: 'wixUrl',
      title: 'Wix Product URL',
      type: 'url',
    },
    {
      name: 'wixProductId',
      title: 'Wix Product ID',
      type: 'string',
      description: 'Required for checkout to work',
    },
    {
      name: 'seoTitle',
      title: 'SEO Title',
      type: 'string',
    },
    {
      name: 'description',
      title: 'Description',
      type: 'text',
    },
    {
      name: 'features',
      title: 'Features',
      type: 'array',
      of: [{ type: 'string' }],
    },
    {
      name: 'variants',
      title: 'Variants',
      type: 'object',
      fields: [
        {
          name: 'type',
          title: 'Variant Type',
          type: 'string',
          description: 'e.g., "MODEL TYPE" or "SIZE"',
        },
        {
          name: 'options',
          title: 'Options',
          type: 'array',
          of: [{ type: 'string' }],
        },
        {
          name: 'required',
          title: 'Required',
          type: 'boolean',
          initialValue: true,
        },
      ],
    },
  ],
  preview: {
    select: {
      title: 'name',
      subtitle: 'category',
      price: 'price',
    },
    prepare(selection) {
      const { title, subtitle, price } = selection;
      return {
        title: title,
        subtitle: `${subtitle} - $${price}`,
      };
    },
  },
};
